/**
 * ElementPalette — 左侧可拖拽元素面板
 *
 * Elements are dragged from here onto the canvas bands.
 * Uses HTML5 native drag since we only transfer data (type)
 * to the drop target, keeping the component zero-weight.
 */

import { PALETTE_ITEMS, type PaletteItem } from './types';

interface ElementPaletteProps {
  collapsed?: boolean;
}

export default function ElementPalette({ collapsed }: ElementPaletteProps) {
  const handleDragStart = (e: React.DragEvent, item: PaletteItem) => {
    e.dataTransfer.setData('application/x-designer-element', JSON.stringify(item));
    e.dataTransfer.effectAllowed = 'copy';
  };

  if (collapsed) return null;

  return (
    <div className="w-56 shrink-0 border-r bg-muted/30 flex flex-col h-full overflow-hidden">
      {/* Header */}
      <div className="px-3 py-2 border-b bg-background/60">
        <h3 className="text-xs font-semibold text-muted-foreground uppercase tracking-wider">
          Elements
        </h3>
        <p className="text-[10px] text-muted-foreground/60 mt-0.5">
          Drag onto canvas
        </p>
      </div>

      {/* Palette items */}
      <div className="flex-1 overflow-y-auto p-2 space-y-1">
        {PALETTE_ITEMS.map((item) => (
          <div
            key={item.type}
            draggable
            onDragStart={(e) => handleDragStart(e, item)}
            className="flex items-center gap-2.5 px-2.5 py-2 rounded-md border border-transparent
                       bg-background hover:bg-accent hover:border-border
                       cursor-grab active:cursor-grabbing
                       transition-all duration-100 select-none
                       hover:shadow-sm active:shadow-md active:scale-[0.97]"
            title={item.description}
          >
            <span className="text-base leading-none w-5 text-center shrink-0">{item.icon}</span>
            <div className="min-w-0">
              <div className="text-xs font-medium truncate">{item.label}</div>
              <div className="text-[9px] text-muted-foreground truncate">{item.description}</div>
            </div>
          </div>
        ))}
      </div>

      {/* Tips */}
      <div className="px-3 py-2 border-t bg-muted/20">
        <p className="text-[9px] text-muted-foreground/60 leading-relaxed">
          💡 Drag an element and drop it onto a band area. Click to select, then edit properties on the right.
        </p>
      </div>
    </div>
  );
}
